module.exports = __webpack_public_path__ + "img/m_contents_delivery@2x.a0bfb0f0.png";